var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPresenceAvailable(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M16,17.28c-2.83,0-5.12-2.6-5.12-5.76a5.26,5.26,0,0,1,5-5.52H16a5.27,5.27,0,0,1,5.14,5.4v.13C21.09,14.7,18.79,17.28,16,17.28Z",
    style: {
      fill: "#6bae44"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8,26a2.06,2.06,0,0,1-1.57-.55c-.26-.33-.08-1,.09-1.39L7,23.13a18.47,18.47,0,0,1,2.61-4,2,2,0,0,1,2.5-.4,7.27,7.27,0,0,1,1.17,1,4,4,0,0,0,2.61.84h.79a4,4,0,0,0,2.56-.84,7.18,7.18,0,0,1,1.07-1,1.87,1.87,0,0,1,2.31.42,16.09,16.09,0,0,1,2.43,4l.46.91c.19.38.38,1,.13,1.39a1.84,1.84,0,0,1-1.46.52Z",
    style: {
      fill: "#6bae44"
    }
  }));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPresenceAvailable);
export default __webpack_public_path__ + "static/media/presence-available.d0560f30.svg";
export { ForwardRef as ReactComponent };